import { useState } from 'react'

// Desc: Custom hook to handle video modal state
const useVideoModal = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [title, setTitle] = useState(null)
  const [url, setUrl] = useState(null)

  const open = (title, url) => {
    setTitle(title)
    setUrl(url)
    setIsOpen(true)
  }

  const close = () => {
    setTitle(null)
    setUrl(null)
    setIsOpen(false)
  }

  return { videoUrl: url, videoTitle: title, openVideoModal: open, closeVideoModal: close, isVideoModalOpen: isOpen }
}

export default useVideoModal
